import {IContestResponse, IContestDetail, IMissionDetail, IRegisterContestResponse} from './types';
import mockContests from '../pages/my-contests/mock/getContestDigitalTwin.json';
import mockContestDetail from '../pages/my-contests/mock/getContentCourse.json';
import mockMissionDetail from '../pages/my-contests/mock/getDataDetailMission.json';
import {api} from "@/api/api-core";

export const Contest = {
  getContests: async (): Promise<IContestResponse> => {
    // return mockContests;
    return api.get(process.env.API_GET_LIST_CONTEST_TWIN as string).then((res) => {
      return res.data || [];
    }).catch((err) => {
      console.log(err);
      return [];
    });
  },

  getMyContests: async (page: number, pageSize: number): Promise<any> => {
    const url = `${process.env.API_GET_MY_CONTEST}?page=${page}&pageSize=${pageSize}`;
    return api.get(url).then((res) => {
      return res.data || [];
    }).catch((err) => {
      console.log(err);
      return [];
    });
  },

  getContestDetail: async (id: any): Promise<IContestDetail> => {
    // return mockContestDetail;
    const url = `${process.env.API_GET_CONTENT_COURSE}?contestId=${id}`;
    return api.get(url).then((res) => {
      return res.data || [];
    }).catch((err) => {
      console.log(err);
      return [];
    });
  },

  getMissionHistory: async (id: any): Promise<IMissionDetail> => {
    // return mockMissionDetail;
    const url = `${process.env.API_GET_MISSION_HISTORY}?activityid=${id}`;
    return api.get(url).then((res) => {
      return res.data || [];
    }).catch((err) => {
      console.log(err);
      return [];
    });
  },

  getDataAsset: async (): Promise<IMissionDetail> => {
    // return mockMissionDetail;
    const url = `${process.env.API_GET_MY_ASSET}`;
    return api.get(url).then((res) => {
      return res.data || [];
    }).catch((err) => {
      console.log(err);
      return [];
    });
  },

  getMediaAsset: async (id: any): Promise<IMissionDetail> => {
    // return mockMissionDetail;
    const url = `${process.env.API_GET_MEDIA_ASSET}?id=${id}`;
    return api.get(url).then((res) => {
      return res.data || [];
    }).catch((err) => {
      console.log(err);
      return [];
    });
  },

  registerContest: async (id: any): Promise<IRegisterContestResponse> => {
    // return mockMissionDetail;
    const url = `${process.env.API_REGISTER_CONTEST}?contestId=${id}`;
    return api.get(url).then((res) => {
      return res.data || [];
    }).catch((err) => {
      console.log(err);
      return [];
    });
  }

}; 